const Accordion = (target) => {

  const transitionDuration = 0.5;

  const el = {
    heads: target.querySelectorAll(".accordion__head"),
    tables: target.querySelectorAll("table")
  };

  const method = {

    init: () => {
      Array.prototype.forEach.call(el.heads, (head) => {
        head.addEventListener("click", method.toggleHead);
      });
      Array.prototype.forEach.call(el.tables, (table) => {
        method.handleTable(table)
      });
    },

    closeItem: (accordionItem) => {
      const accordionBody = accordionItem.querySelector(".accordion__body");
      // get the height
      const accordionBodyHeight = accordionBody.getBoundingClientRect().height;
      accordionItem.classList.remove("accordion__item--selected");
      // set inline height
      accordionBody.style.height = `${accordionBodyHeight}px`;
      // zero the height (animate)
      setTimeout(() => {
        accordionBody.style.height = 0;
        // remove inline height after the transition
        setTimeout(() => accordionBody.removeAttribute("style"), transitionDuration * 1000);
      }, 10);
    },

    openItem: (accordionItem) => {
      console.log('open')
      accordionItem.classList.add("accordion__item--selected");
      // get the height (after opened)
      const accordionBody = accordionItem.querySelector(".accordion__body");
      const accordionBodyHeight = accordionBody.getBoundingClientRect().height;
      // immediately zero the height (don't open yet)
      accordionBody.style.height = 0;
      // set inline height to animate
      setTimeout(() => {
        accordionBody.style.height = `${accordionBodyHeight}px`;
        // remove inline height after the transition
        setTimeout(() => accordionBody.removeAttribute("style"), transitionDuration * 1000);
      }, 10);
    },

    toggleHead: (event) => {
      const accordionItem = event.currentTarget.parentElement;
      const accordionItemIsSelected = accordionItem.classList.contains("accordion__item--selected");
      const accordion = accordionItem.parentElement;

      if (!accordionItemIsSelected) {
        // if it's not a multi accordion stick to default behaviour (close other opened items)
        // if (accordion.getAttribute("data-mode") !== "multi") {
        //   const selectedItem = accordion.querySelector(".accordion__item--selected");
        //   if (selectedItem) method.closeItem(selectedItem);
        // }
        // open the item
        method.openItem(accordionItem);
      } else {
        // close current item (if it was opened)
        method.closeItem(accordionItem);
      }
    },

    handleTable: (table) => {
      const wrapperEl = document.createElement('div')
      wrapperEl.classList.add("table-wrapper")
      const innerWrapperEl = document.createElement('div')
      innerWrapperEl.classList.add("table-wrapper__inner")

      // Store the parent and the next sibling before moving the table
      const parent = table.parentElement
      const nextSibling = table.nextSibling

      // Build the wrapper structure
      innerWrapperEl.appendChild(table)
      wrapperEl.appendChild(innerWrapperEl)
      
      // Insert the wrapped table either before the next sibling or at the end of parent
      if (nextSibling) {
        parent.insertBefore(wrapperEl, nextSibling)
      } else {
        parent.appendChild(wrapperEl)
      }
    }
  };

  method.init();
};

export default Accordion;
